import { gql } from '@apollo/client';

/**
 * Fragment for successful test order response
 */
export const TestOrderResponseFragment = gql`
  fragment TestOrderResponseFragment on TestOrderResponse {
    message
  }
`;

/**
 * Fragment for input validation failure
 */
export const InputValidationFailureFragment = gql`
  fragment InputValidationFailureFragment on InputValidationFailure {
    message
    responseType
  }
`;

/**
 * Mutation to mark an order as a test order
 * Returns either a success or validation failure response
 *
 * @param orderId - The ID of the order to mark as test
 */
export const SetOrderAsTestMutation = gql`
  mutation SetOrderAsTest($orderId: ID!) {
    setOrderAsTest(orderId: $orderId) {
      ...TestOrderResponseFragment
      ...InputValidationFailureFragment
    }
  }
  ${TestOrderResponseFragment}
  ${InputValidationFailureFragment}
`;
